import { useI18n } from "../i18n";
import { LANGUAGE_NAMES, type Lang } from "../i18n/strings";
import { useThemeContext } from "./ThemeContext";
import { IconMoon, IconSun } from "./icons";

/** Theme and language switches, shown quietly in the page corner. Only the operator's languages. */
export function Preferences() {
  const { t, lang, setLang, languages } = useI18n();
  const { theme, toggle } = useThemeContext();
  return (
    <div className="prefs">
      {languages.length > 1 ? (
        <label className="prefs-lang">
          <span className="sr-only">{t("common.language")}</span>
          <select value={lang} onChange={(e) => setLang(e.target.value as Lang)}>
            {languages.map((l) => (
              <option key={l} value={l}>
                {LANGUAGE_NAMES[l]}
              </option>
            ))}
          </select>
          <span className="prefs-lang-code" aria-hidden="true">
            {lang.toUpperCase()}
          </span>
        </label>
      ) : null}
      <button
        type="button"
        className="icon-btn"
        onClick={toggle}
        aria-label={theme === "dark" ? t("common.themeLight") : t("common.themeDark")}
        title={theme === "dark" ? t("common.themeLight") : t("common.themeDark")}
      >
        {theme === "dark" ? <IconSun size={17} /> : <IconMoon size={17} />}
      </button>
    </div>
  );
}
